import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Observable } from "rxjs";

export interface CanComponentDeactivate {
  CanDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}

@Injectable({ providedIn: 'root' })

export class Candeactivate {
  router: Router;
  constructor(router: Router) {
    this.router = router;
  }
  canDeactivate(component: CanComponentDeactivate): Observable<boolean> | Promise<boolean> | boolean {
    return component.CanDeactivate(); //the function will be called on the component, that's why we'll implement the function on the component.
  }
}
